<template>
<div class="store bg-light min-vh-100">
    <div class="container-fluid px-xl-5 py-4">
        
        <div v-if="searchVisible" class="row justify-content-center mb-4">
            <!-- <search></search> -->
        </div>
        
        <div class="row">
            <emenu class="col-lg-3 col-md-4 col-12 mb-4 mb-md-0 pr-lg-4"></emenu>
            
            <div class="col-lg-9 col-md-8 col-12">
                <!-- Título de la Categoría o Búsqueda en la parte superior -->
                <div class="mb-4 pb-2 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h1 class="h3 fw-bold m-0 text-dark" style="text-transform: uppercase; letter-spacing: 1.5px; color: #713083 !important;">
                        {{ searchTerm ? 'Resultados para: "' + searchTerm + '"' : (currentCategory ? currentCategory.nombre : 'Catálogo de Productos') }}
                    </h1>
                    <button v-if="searchTerm" @click="limpiarBusqueda" class="btn btn-outline-secondary btn-sm rounded-pill px-3">
                        <font-awesome-icon icon="times" class="me-1" /> Limpiar búsqueda
                    </button>
                </div>

                <!-- Banner presentacion categoria -->
                <div class="mb-4" v-if="!searchTerm && currentCategory && currentCategory.banner">
                    <img :src="`${dominio}/img/categorias/${currentCategory.banner}`" class="w-100 rounded shadow-sm" style="object-fit: cover; max-height: 250px;" alt=""/>
                </div>

                <!-- Categorias Destacadas (Subniveles) -->
                <div v-if="!searchTerm && currentSubcategories.length > 0" class="mb-5 mt-2">
                    <h2 class="h4 text-dark mb-4 text-start" style="font-weight: 500; font-size: 1.8rem; color: #000;">Categorías destacadas</h2>
                    <div class="row flex-wrap">
                        <div v-for="subcat in currentSubcategories" :key="subcat.id" class="col-6 col-lg-3 col-md-4 mb-4">
                            <div class="subcat-card position-relative overflow-hidden bg-white d-flex flex-column" style="cursor: pointer; border-radius: 8px; border: 1px solid #eee; height: 200px;" @click="filtrarCategoria(subcat.id)">
                                <div class="flex-grow-1 w-100 overflow-hidden">
                                     <img v-if="subcat.imagen" :src="`${dominio}/img/categorias/${subcat.imagen}`" class="subcat-img w-100 h-100" style="object-fit: cover; transition: transform 0.4s ease;"/>
                                     <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                                         <font-awesome-icon icon="images" class="text-secondary" style="font-size: 3rem;" />
                                     </div>
                                </div>
                                <div class="w-100 text-center py-2 bg-white">
                                    <span class="text-dark fw-bold text-uppercase" style="font-size: 0.75rem; letter-spacing: 0.5px;">{{ subcat.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Mensaje cuando no hay resultados de búsqueda -->
                <div v-if="searchTerm && (!sorted || sorted.length === 0)" class="text-center py-5 bg-white rounded border shadow-sm my-4 px-3">
                    <font-awesome-icon icon="search" class="text-muted mb-3" style="font-size: 3.5rem; opacity: 0.5;" />
                    <h4 class="fw-bold text-dark mb-2">No encontramos resultados para "{{ searchTerm }}"</h4>
                    <p class="text-muted mb-4">Intenta buscar con otra palabra clave como "bolsa", "caja", "doypack", "kraft" o navega por nuestras categorías.</p>
                    <button @click="limpiarBusqueda" class="btn text-white px-4 py-2 rounded-pill font-weight-bold shadow-sm" style="background-color: #713083;">
                        Ver todos los productos
                    </button>
                </div>

                <products v-else class="products"></products>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Products from '@/components/Products.vue'
import Emenu from '@/components/Emenu.vue'
import Search from '@/components/Search.vue'
import { FadeTransition } from 'vue2-transitions'
import { mapState } from 'vuex'


export default {
components: {
    Products,
    Emenu,
    Search,
    FadeTransition
    },
    computed: {
        ...mapState(['searchVisible', 'filterCat', 'categories', 'dominio', 'searchTerm', 'sorted']),
        currentCategory() {
            if (!this.filterCat) return null;
            let found = null;
            const findCat = (id, cats) => {
                for (let c of cats) {
                    if (c.id === id) return c;
                    if (c.sublevels && c.sublevels.length > 0) {
                        let res = findCat(id, c.sublevels);
                        if (res) return res;
                    }
                }
                return null;
            };
            return findCat(this.filterCat, this.categories);
        },
        currentSubcategories() {
            let cat = this.currentCategory;
            if (cat && cat.sublevels && cat.sublevels.length > 0) {
                return cat.sublevels;
            }
            return [];
        }
    },
    methods: {
        filtrarCategoria(id) {
            this.$store.dispatch('getProductosCat', id);
            this.$router.push('/tienda/' + id);
        },
        limpiarBusqueda() {
            this.$store.commit('clearAllFilters');
        }
    },
    mounted() {
        if (this.$route.params.id) {
            this.$store.dispatch('getProductosCat', this.$route.params.id);
        }
    },
    watch: {
        '$route.params.id'(newId) {
            if (newId) {
                this.$store.dispatch('getProductosCat', newId);
            }
        }
    }
}
</script>

<style scoped>
.subcat-card {
    transition: box-shadow 0.3s ease;
}
.subcat-card:hover {
    box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}
.subcat-card:hover .subcat-img {
    transform: scale(1.08);
}
</style>
